import React from 'react';

function BlogPostDetail({ post, onBack }) {
  if (!post) return null;

  return (
    <div className="blog-post-detail" style={{ maxWidth: '850px', margin: '0 auto', padding: '2rem 1.5rem' }}>
      {/* Navigation Breadcrumb & Back button */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2.5rem' }}>
        <button 
          onClick={onBack}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: 'var(--text-primary)', 
            fontWeight: 700, 
            fontSize: '0.9rem', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.5rem', 
            cursor: 'pointer',
            padding: 0
          }}
        >
          <span style={{ color: 'var(--accent-color)', fontSize: '1.2rem' }}>←</span> Back to Articles
        </button>
        <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
          Blog / {post.category}
        </span>
      </div>

      {/* Article Header */}
      <header style={{ marginBottom: '3rem', borderBottom: '1px solid var(--border-color)', paddingBottom: '2rem' }}>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1.2rem' }}>
          <span style={{ color: 'var(--text-primary)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', background: 'var(--border-color)', padding: '0.3rem 0.8rem', borderRadius: '4px' }}>
            {post.category}
          </span>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>•</span>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{post.readTime}</span>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>•</span>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Published August 2026</span>
        </div>
        
        <h1 style={{ fontFamily: 'var(--font-title)', fontSize: '3rem', fontWeight: 900, textTransform: 'uppercase', lineHeight: '1.2', color: 'var(--text-primary)', marginBottom: '1.5rem' }}>
          {post.title}
        </h1>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: 'var(--accent-color)', display: 'flex', alignItems: 'center', justifycontent: 'center', fontWeight: 'bold', color: 'white', justifyContent: 'center' }}>
            SB
          </div>
          <div>
            <h4 style={{ margin: 0, fontSize: '0.95rem', fontWeight: 700 }}>Saveera Biotech Editorial</h4>
            <p style={{ margin: 0, fontSize: '0.8rem', color: 'var(--text-muted)' }}>Technology & Marketing Analysts</p>
          </div>
        </div>
      </header>

      {/* Article Content */}
      <article className="blog-article-content">
        {post.bodyParagraphs && post.bodyParagraphs.map((para, i) => {
          // If the paragraph starts with a header prefix like "###", render as subtitle
          if (para.startsWith('###')) {
            return (
              <h3 
                key={i} 
                style={{ 
                  fontFamily: 'var(--font-title)', 
                  fontSize: '1.6rem', 
                  fontWeight: 800, 
                  textTransform: 'uppercase', 
                  color: 'var(--text-primary)', 
                  marginTop: '2.5rem', 
                  marginBottom: '1.2rem',
                  letterSpacing: '0.5px'
                }}
              >
                {para.replace('###', '').trim()}
              </h3>
            );
          }
          
          return (
            <p 
              key={i} 
              style={{ 
                marginBottom: '1.6rem', 
                color: 'var(--text-secondary)', 
                fontSize: '1.08rem', 
                lineHeight: '1.8',
                textAlign: 'justify'
              }}
            >
              {para}
            </p>
          );
        })}
      </article>

      {/* Bottom Actions */}
      <footer style={{ marginTop: '4rem', paddingTop: '2.5rem', borderTop: '1px solid var(--border-color)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <button 
          onClick={onBack}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: 'var(--text-primary)', 
            fontWeight: 700, 
            fontSize: '0.9rem', 
            textTransform: 'uppercase', 
            letterSpacing: '1px', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.5rem', 
            cursor: 'pointer',
            padding: 0
          }}
        >
          <span style={{ color: 'var(--accent-color)' }}>←</span> Back to Articles
        </button>

        <span style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
          Thank you for reading!
        </span>
      </footer>
    </div>
  );
}

export default BlogPostDetail;
